import React, { Fragment, Suspense, lazy } from "react";
import { ThemeProvider, StyledEngineProvider, CssBaseline } from "@mui/material";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import theme from "./theme";
import GlobalStyles from "./GlobalStyles";
import ReactGA from 'react-ga';


// import Pace from "./shared/components/Pace";

import LoggedInComponent from "./logged_in/components/Main";

import LoggedOutComponent from "./logged_out/components/Main";
if (`${process.env.REACT_APP_ENV}` === 'production'){
  ReactGA.initialize("G-LWES1S3VQV");

  ReactGA.pageview(window.location.pathname);
}else{
  console.log("current env", `${process.env.REACT_APP_ENV}`);
}
// <Pace color={theme.palette.primary.light} />
function App() {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles />

          <Suspense fallback={<Fragment />}>
            <Switch>
              <Route path="/c">
                <LoggedInComponent />
              </Route>
              <Route>
                <LoggedOutComponent />
              </Route>
            </Switch>
          </Suspense>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

export default App;
